(function () {
  'use strict';

  /* @ngdoc object
   * @name events.vehicles.deposits.list
   * @description
   *
   */
  angular
    .module('events.vehicles.deposits.list', [
      'ui.router'
    ]);
}());
